<template>
	<div class="filter-overlay">
		<div class="reveal-content">
			<div class="overlay-title-conatiner">
				<button class="button btn-back" aria-label="Close alert" type="button" @click="$emit('close-reveal')">
					<font-awesome-icon :icon="['fas', 'chevron-left']" />
				</button>
				<span class="overlay-title">
					{{ $t('filterLabels.overlayHeadline') }}
				</span>
			</div>

			<ul class="accordion" data-accordion data-allow-all-closed>
				<li class="accordion-item" data-accordion-item ref="accordion-item-radius-search" v-show="allowRange">
					<a href="#" class="accordion-title">
						{{ $t('filterLabels.radius') }}
					</a>
					<div class="accordion-content" data-tab-content>
						<div class="slider-value-display">{{ displayValue }}</div>
						<vue-slider ref="slider" v-model="range" :min="10" :max="150" clickable tooltip="none" :interval="10" :dotStyle="{ width: '1.25rem', height: '1.25rem' }" />
					</div>
				</li>
				<li class="accordion-item" data-accordion-item ref="accordion-item-category-filter" v-show="enableCategories">
					<a href="#" class="accordion-title">
						{{ $t('filterLabels.category') }}
					</a>
					<div class="accordion-content" data-tab-content>
						<fieldset class="categories-filter">
							<div class="category-item" v-for="cat in entityCategories" :key="`cat-${cat.id}`">
								<input :id="`category-${cat.id}`" type="checkbox" :value="cat.id" v-model="checkedCategories">
								<label :for="`category-${cat.id}`">{{ cat.name }}</label>
							</div>
						</fieldset>
					</div>
				</li>
				<li class="accordion-item" data-accordion-item ref="accordion-item-category-filter" v-show="enableCriterias">
					<a href="#" class="accordion-title">
						{{ $t('filterLabels.criterias') }}
					</a>
					<div class="accordion-content" data-tab-content>
						<fieldset class="criterias-filter">
							<div class="critera-item" v-for="criteria in criterias" :key="`criteria-${criteria.id}`">
								<input :id="`criteria-${criteria.id}`" type="checkbox" :value="criteria.id" v-model="checkedCriterias">
								<label :for="`criteria-${criteria.id}`">{{ criteria.name }}</label>
							</div>
						</fieldset>
					</div>
				</li>
			</ul>

			<div class="top-performance-container" v-show="enableTopPerformance">
				<label for="cb-top-performance">
					<input id="cb-top-performance" type="checkbox" v-model="onlyTopPerformanceEntities">
					{{ $t('filterLabels.topPerformanceCheckbox') }}
				</label>
			</div>

			<div class="actions-container">
				<div class="reset-btn-container btn-container">
					<button type="button" @click="resetAllFilters" class="btn-reset">
						<font-awesome-icon :icon="['fal', 'times']" />{{ $t('filterLabels.resetFilters') }}
					</button>
				</div>
				<div class="show-results-btn-container btn-container">
					<button class="button expand btn-show-results" aria-label="Close alert" type="button" @click="$emit('close-reveal')">
						<span class="btn-text">{{ $t('filterLabels.showResults') }}</span> 
						<span>({{ count }})</span>
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import VueSlider from 'vue-slider-component'
	import foundation from '@/mixins/foundation'

	export default {
		name: 'FilterOverlay',
		mixins: [ foundation ],
		components: {
			VueSlider
		},
		props: {
			entities: {
				type: String,
				default: ''
			},
			enableCategories: {
				type: Boolean,
				default: false
			},
			enableCriterias: {
				type: Boolean,
				default: false
			},
			enableRange: {
				type: Boolean,
				default: false
			},
			enableTopPerformance: {
				type: Boolean,
				default: false
			},
			entityCategories: {
				type: Array,
				default () {
					return []
				}
			},
			criterias: {
				type: Array,
				default: () => {
					return []
				}
			}
		},
		data () {
			return {
				count: 0,
				range: 150,
				checkedCategories: [],
				checkedCriterias: [],
				onlyTopPerformanceEntities: false
			}
		},
		computed: {
			allowRange () {
				if (this.$store.state.currentPosition && this.enableRange) {
					return true
				} else {
					return false
				}
			},
			filteredResultsCount () {
				return this.$store.getters.getFilteredResultsCount(this.entities)
			},
			selectedRange () {
				if (this.enableRange){
					return this.$store.getters.getSelectedRange(this.entities)
				}
				return 0
			},
			selectedCategories ()  {
				if (this.enableCategories) {
					return this.$store.getters.getSelectedCategories(this.entities)
				}
				return []
			},
			selectedCriterias (){
				if (this.enableCriterias) {
					return this.$store.getters.getSelectedCriterias(this.entities)
				}
				return []
			},
			allowOnlyTopPerformanceEntities () {
				if (this.enableTopPerformance) {
					return this.$store.getters.getTopPerformanceState(this.entities)
				}
				return false
			},
			displayValue () {
				if (this.range <= 140 ) {
					return `< ${this.range} km`
				} else {
					return `> ${this.range} km`
				}
			}
		},
		watch: {
			filteredResultsCount: function(count) {
				this.count = count
			},
			checkedCategories: function(checkedCategories) {
				this.$store.dispatch('updateSelectedCategories', { entity: this.entities, categories: checkedCategories })
			},
			checkedCriterias: function(checkedCriterias) {
				this.$store.dispatch('updateSelectedCriterias', { entity: this.entities, criterias: checkedCriterias })
			},
			onlyTopPerformanceEntities: function(tps) {
				this.$store.dispatch('updateTopPerformanceSelection', { entity: this.entities, newState: tps })
			},
			range: function(newValue) {
				this.$store.dispatch('updateSelectedRange', { entity: this.entities, newRange: newValue })
			}
		},
		methods: {
			resetAllFilters () {
				this.$store.dispatch('resetFilter', { entity: this.entities })

				this.count = 0
				this.range = 150
				this.checkedCategories = []
				this.checkedCriterias = []
				this.onlyTopPerformanceEntities = false

				this.$emit('reset-filters')
			}
		},
		mounted () {
			// init cats
			this.selectedCategories.forEach(cat => {
				this.checkedCategories.push(cat.id)
			}, this)
			this.selectedCriterias.forEach(criteria => {
				this.checkedCriterias.push(criteria.id)
			}, this)
			this.onlyTopPerformanceEntities = this.allowOnlyTopPerformanceEntities
			this.count = this.filteredResultsCount
			this.range = this.selectedRange
		}
	}
</script>

<style lang="scss">
	.vue-slider{
		.vue-slider-rail,
		.vue-slider-process{
			height: 5px;
			background-color: get-color(primary) !important;
		}
		.vue-slider-dot{
			width: 1.25rem !important;
			height: 1.25rem !important;

			.vue-slider-dot-handle{
				border: 2px solid get-color(primary) !important;
			}
		}
	}
	.slider-value-display{
		margin-bottom: .5rem;
		text-align: center;
		color: get-color(primary);
	}
</style>

<style lang="scss" scoped>
	@import '~vue-slider-component/theme/antd.css';

	.filter-overlay{
		padding: 0 !important;
		background-color: $light-gray;
		display: block;
		opacity: 0;
		visibility: hidden;
		transition: all .15s ease-in-out;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: -2;

		&.is-reveal-open{
			z-index: 1000;
			background-color: rgba($black, .8);
			opacity: 1;
			visibility: visible;
			
			.reveal-content{
				visibility: visible;
				opacity: 1;
			}
		}

		.reveal-content{
			background-color: $white;
			visibility: hidden;
			opacity: 0;
			overflow-y: scroll;

			height: 100vh;

			@include breakpoint(medium) {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				max-width: rem-calc(530);

				height: auto;
			}
		}

		.overlay-title-conatiner{
			@include xy-gutters($gutter-type: padding, $gutter-position: top left right);
			display: flex;
			justify-content: flex-start;
			align-items: center;
			margin-bottom: rem-calc(54);

			.overlay-title{
				margin-left: 1rem;
				font-size: rem-calc(12);
				font-weight: 600;
				text-transform: uppercase;
			}
		}

		.accordion {
			margin-bottom: 0;
			.accordion-item{
				border-bottom: 1px solid rgba($medium-gray, .2);

				&:first-child{
					border-top: 1px solid rgba($medium-gray, .2);					
				}

				&.is-active{
					.accordion-title{
						&:before{
							font-family: 'Font Awesome 5 Pro';
							content: '\f077';
						}
					}
				}
			}

			.accordion-title{
				font-weight: bold;


				&:before{
					font-family: 'Font Awesome 5 Pro';
					content: '\f078';
				}
			}
		}

		.top-performance-container{
			label {
				@include xy-gutters($gutter-type: padding, $gutter-position: top left bottom right);
				color: get-color(primary);
				font-weight: 600;
				font-size: 1rem;
				background-color: $white;
				border-bottom: 1px solid rgba($medium-gray, .2);
			}
		}

		.actions-container{
			box-shadow: 0px 0px 2px rgba($black, .15);
			margin-top: 2rem;
			padding: 1rem;

			> .btn-container{
				padding-top: 1rem;
			}

			.btn-container{
				&.reset-btn-container{
					text-align: center;

					.btn-reset{
						cursor: pointer;
						color: $medium-gray;

						svg{
							margin-right: .5rem;
						}
					}
				}

				&.show-results-btn-container{
					text-align: center;
					.btn-show-results{
						min-width: rem-calc(250);
						border-radius: 20rem;
						text-transform: uppercase;
					}
				}
			}
		}
	}
</style>